/** Shortens an ISO date ("2026-06-23") to an axis-friendly label ("Jun 23"). */
export function formatChartDate(dateStr: string): string {
  const d = new Date(dateStr)
  if (Number.isNaN(d.getTime())) return dateStr
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
}

/** Caps the number of visible X-axis ticks (~6) regardless of series length. */
export function tickInterval(pointCount: number): number {
  return Math.max(0, Math.ceil(pointCount / 6) - 1)
}
